export default class UniqueIdGenerator {
  static uuid() {
    return 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'.replace(/[x]/g, (c) => {
      let num = Math.random() * 16 | 0, v = c === 'x' ? num : (num & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  static id(length = 8) {
    let id = "";
    let charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    for (let i = 0; i < length; i++) {
      id += charset.charAt(Math.floor(Math.random() * charset.length));
    }
    return id;
  }
}




// WEBPACK FOOTER //
// ./src/core/utils/uniqueIdGenerator.js